import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as PackageInventoryStore from '../../../../../redux/packageInventory';
import References from '../../../../shared/vulns/Drawer/References';

/**
 * Container component for the VulnerabilityDrawerReferences
 */
const PackageVersionVulnerabilityDrawerReferences: VoidFunctionComponent = () => {
  //  References is an array of URLs.
  const references = useSelector(PackageInventoryStore.selectors.getSelectedVulnReferences);
  return (
    <References references={references} />
  );
};

export default PackageVersionVulnerabilityDrawerReferences;
